/**
 * Cache + fetch de la signature Gmail de l'user.
 *
 * Source : `users.settings.sendAs.list` → on prend l'entrée `isDefault` (ou
 * `isPrimary` ou la 1ère). Renvoie le HTML de la signature.
 *
 * Stratégie cache : load IndexedDB instant + fetch frais en background.
 */

import { get, set } from "idb-keyval";
import { listSendAs } from "./api";

const SIG_KEY = "mailfox:gmail:signature";

interface CachedSignature {
  html: string;
  fetchedAt: number;
}

export async function loadCachedSignature(): Promise<string | null> {
  const cached = await get<CachedSignature>(SIG_KEY);
  return cached?.html ?? null;
}

export async function refreshSignature(): Promise<string> {
  const list = await listSendAs();
  const def =
    list.find((s) => s.isDefault) ||
    list.find((s) => s.isPrimary) ||
    list[0];
  const html = (def?.signature ?? "").trim();
  await set(SIG_KEY, { html, fetchedAt: Date.now() } as CachedSignature);
  return html;
}

/**
 * Renvoie la signature la plus récente possible :
 *   - cache instant si dispo
 *   - puis refresh background pour la prochaine fois
 */
export async function getSignature(): Promise<string> {
  const cached = await loadCachedSignature();
  if (cached !== null) {
    // Background refresh, ne pas attendre
    void refreshSignature().catch((e) =>
      console.warn("signature refresh failed:", e),
    );
    return cached;
  }
  // 1ère utilisation → fetch synchrone
  return refreshSignature();
}
